import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { normalizeSoeidRecord } from "../components/Report/All/Investigation2/Involved/soeidRecord";

/**
 * Nómina de Banamex: búsqueda de empleados contra el archivo que entrega el
 * banco, cargado en el tenant (`manage.py load_banamex_nomina`).
 *
 *   GET /<tenant>/api/banamex/nomina/search/
 *
 * Se manda EXACTAMENTE uno de los tres criterios; el backend rechaza con 400 si
 * llegan dos o ninguno:
 *   soeid     uno o varios, separados por coma
 *   employee  números de empleado, con o sin ceros a la izquierda
 *   name      texto libre, mínimo 3 letras; todas las palabras deben aparecer
 *
 * Solo responde en los tenants de Banamex (403 en el resto) y devuelve 503
 * mientras la nómina no se haya cargado.
 */
const searchNomina = async (params) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return null;

  const resp = await apiCall.get(`${tenant}/api/banamex/nomina/search/`, {
    params,
    headers: {
      IdToken: session.IdToken,
      Authorization: `Bearer ${session.AccessToken}`,
    },
  });
  return resp.data;
};

/**
 * Registros de nómina de UN SOEID.
 *
 * Un SOEID puede tener varios registros (reingresos, o la persona aparece en
 * más de una empresa); llegan con el vigente primero (activo y con el
 * movimiento más reciente). La lista vacía significa que ese SOEID no está en
 * la nómina cargada, que no es un error.
 *
 * @param {string} soeid
 * @returns {Promise<{loadedAt: string|null, records: Array<Object>}>}
 *   `records` ya normalizado por normalizeSoeidRecord
 */
export const getEmployeeBySoeid = async (soeid) => {
  const term = String(soeid ?? "").trim();
  if (!term) throw new Error("SOEID requerido");

  const data = await searchNomina({ soeid: term });
  // Se pidió un solo SOEID, así que solo hay un grupo de resultados.
  const records = data?.results?.[0]?.records || [];

  return {
    loadedAt: data?.loadedAt || null,
    records: records.map(normalizeSoeidRecord),
  };
};
